import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
    GetWebhooks({ commit }, list) {
        return new Promise((resolve, reject) => {
            axios({
                url: "/did/webhook/list" ,
                params: {
                    page: list.page || 0,
                    per_page: list.per_page || 10,
                    number: list.number ? list.number : '',
                },
                method: "GET"
            }).then(res => {
                resolve(res.data.payload);
            }).catch(err => {
                reject(err);
            });
        });
    },
    AddWebhook({ commit }, data) {
        return new Promise( (resolve, reject) => {
            axios({
                url: "/did/webhook" ,
                data: data,
                method: "POST"
            }).then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err);
            });
        });
    },
    EditWebhook({ commit }, data) {
        return new Promise( (resolve, reject) => {
            axios({
                url: "/did/webhook/" + data.id ,
                data: data,
                method: "PATCH"
            }).then(res => {
                resolve(res.data.payload);
            })
            .catch(err => {
                reject(err);
            });
        });
    },
    GetWebhook({ commit }, id) {
        return new Promise( (resolve, reject) => {
            axios({
                url: "/did/webhook/" + id,
                method: "GET"
            }).then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
        });
    },
    DeleteWebhook({ commit }, id) {
        return new Promise( (resolve, reject) => {
            axios({
                url: "/did/webhook/" + id,
                method: "DELETE"
            }).then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
        });
    },

};

// mutations
const mutations = {

};

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
};
